export const isDemoOnly = process.env.REACT_APP_DEMO_ONLY === "true";

const LIVE_CONTACT = {
  phoneDisplay: "+852 6822 8544",
  phoneHref: "tel:+85268228544",
  whatsappHref: "https://wa.me/85268228544?text=查詢洗冷氣",
  facebookHref:
    "https://www.facebook.com/profile.php?id=100057489637948",
  instagramHref: "http://google.com",
} as const;

const DEMO_CONTACT = {
  phoneDisplay: "[Demo Phone]",
  phoneHref: undefined,
  whatsappHref: undefined,
  facebookHref: undefined,
  instagramHref: undefined,
} as const;

export const CONTACT = isDemoOnly ? DEMO_CONTACT : LIVE_CONTACT;
